/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as React from 'react';
import { GlobalState } from '../../actions';
import { connect } from 'react-redux';
import { SongLink } from '../SongLink';
import { Dispatch } from 'redux';
import { Table } from 'reactstrap';
import { AlbumSong } from '../../../services/playlist';

interface AlbumSongListProps {
    albumSongs: AlbumSong[];
}

class AlbumSongList extends React.Component<AlbumSongListProps> {

    renderAlbumSong(albumSong: AlbumSong) {
        return (
            <tr key={albumSong.id}>
                <td><SongLink songId={albumSong.songId}>{albumSong.name}</SongLink></td>
                <td>{albumSong.artist}</td>
            </tr>
        );
    }

    render() {
        return (
            <>
                <Table striped={true}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Artist</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.props.albumSongs.map((as) => this.renderAlbumSong(as))}
                    </tbody>
                </Table>
            </>
        );
    }
}

const mapStateToProps = (state: GlobalState) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumSongList);